export enum SATStaticFigure {
  ALBERT_EINSTEIN = 'Albert Einstein',
}
